import loadItemReadingPane from './loadItemReadingPane';
import setItemPrintPaneViewState from './setItemPrintPaneViewState';
import datapoints from '../datapoints';
import { logUsage, wrapFunctionForDatapoint } from 'owa-analytics';
import type { ActionSource } from 'owa-analytics-types';
import type { ClientItemId } from 'owa-client-ids';
import { lazyReloadSecondaryTabAsDeeplink } from 'owa-tab-store';

export default wrapFunctionForDatapoint(
    datapoints.PrintItem,
    function print(
        itemId: ClientItemId,
        actionSource: ActionSource,
        targetWindow: Window | undefined
    ): Promise<void> {
        const itemIdToPrint = itemId;
        if (itemIdToPrint) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (21,19): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            const isProjection: boolean = targetWindow && targetWindow !== window;
            if (isProjection) {
                logUsage('printFromProjection');
                lazyReloadSecondaryTabAsDeeplink.importAndExecute(itemIdToPrint.Id, {
                    Print: '',
                });
            } else {
                return loadItemReadingPane(
                    itemIdToPrint,
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2345 (33,21): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext | undefined'.
                    // @ts-expect-error
                    null /* instrumentationContext */,
                    setItemPrintPaneViewState,
                    { isPrint: true }
                );
            }
        }

        return Promise.resolve();
    }
);
